import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
//locale
import {IconDocumentPen} from "components/icons";
import OfferTopInfo from "./OfferTopInfo";
import OfferDescription from "./OfferDescription";
import LoadDocsColumn from "components/LoadDocsColumn";
import SmartFormAnswers from "pages/OurRequests/components/SmartForm/SmartFormAnswers";
import ButtonPrint from "components/buttons/ButtonPrint";
import Confetti from "components/Confetti";

const OfferCardView = ({offer, offerFiles, language, user, sideData, clickEdit}) => {
  const {t} = useTranslation();

  const reguestInfo = useMemo(
    () => `${offer?.projectName}・${offer?.requestName}・${offer?.organizationName}.pdf`,
    [offer]
  );
  const printPageTitle = useMemo(() => `${t("ANBUD")}・${reguestInfo}`, [reguestInfo, t]);

  const buttonPrint = (
    <ButtonPrint
      infoTooltip="PRINT_OFFER_BUTTON_INFO_TOOLTIP"
      printTitle={printPageTitle}
      right="0px"
    />
  );

  const createdAt = useMemo(() => offer?.createdAt, [offer]);
  const currentTime = useMemo(() => new Date(), []);
  const offerCreationTime = useMemo(
    () => (createdAt ? new Date(createdAt) : null),
    [createdAt]
  );
  const timeDifference = useMemo(
    () => (offerCreationTime ? currentTime - offerCreationTime : null),
    [offerCreationTime, currentTime]
  );
  const showConfetti = useMemo(
    () => timeDifference !== null && timeDifference <= 5000,
    [timeDifference]
  );

  return (
    <div className="offer-card-view__wrapper">
      <Confetti trigger={showConfetti} />
      <OfferTopInfo
        offer={offer}
        sideData={{
          ...sideData,
          buttonPrint: sideData.needButtonPrint ? buttonPrint : null,
        }}
        language={language}
        clickEdit={clickEdit}
      />
      <OfferDescription {...sideData.description} />
      <LoadDocsColumn
        title={sideData.labels.documents}
        titleIcon={<IconDocumentPen />}
        button="ADD_DOCUMENT"
        needZipButton
        docs={offerFiles ?? []}
        fullWidth
        needAuthorInfo
        needShowDeleted
        currentUser={user}
      />

      <SmartFormAnswers
        isNew={false}
        isEdit={false}
        isSellerSide
        titleHide={!offer?.smartFormQuestions?.length}
        questions={offer?.smartFormQuestions}
        answers={offer?.smartFormAnswers ?? []}
      />
    </div>
  );
};

export default OfferCardView;
